<form [formGroup]="form" (ngSubmit)="onSaveDataCard()">

  <!-- Main Form -->
  @if (displayMainForm) {
    <hr>
    <div class="form-group fs-12">
      <div class="row">
        <div class="col-lg col-lg-3">
          <label class="text-sm-right d-block" for="test-condition">Test Condition</label>
        </div>
        <div class="col-lg col-lg-9">
        <textarea
          id="test-condition"
          class="form-control"
          appTextareaResize
          [readOnly]="disabledMainFormControls"
          [formControl]="condition"></textarea>
          @if (condition.errors && (condition.dirty || condition.touched)) {
            @if (condition.errors.required) {
              <div class="invalid-feedback force-show small">
                Test Condition is required.
              </div>
            }
          }
        </div>
      </div>
    </div>

    <div class="form-group fs-12">
      <div class="row">
        <div class="col-lg col-lg-3">
          <label class="text-sm-right d-block" for="user-comments">User Comments</label>
        </div>
        <div class="col-lg col-lg-9">
        <textarea
          id="user-comments"
          class="form-control"
          appTextareaResize
          [readOnly]="disabledMainFormControls"
          [formControl]="comment"></textarea>
          @if (comment.errors && (comment.dirty || comment.touched)) {
            @if (comment.errors.required) {
              <div class="invalid-feedback force-show small">
                User Comment is required.
              </div>
            }
          }
        </div>
      </div>
    </div>

    <div class="form-group mb-1">
      <div class="row">
        <div class="col-lg offset-3 col-lg-5 text-sm-left fs-12">
          User Sel. Code<small></small>
        </div>
      </div>
    </div>
    <div class="form-group fs-12">
      <div class="row">
        <div class="col-lg col-lg-3">
          <label class="text-sm-right d-block text-capitalize" for="valve">
            {{ getEqLabel(mainFormData?.Object_TypicalType) }}
          </label>
        </div>
        <div class="col-lg col-lg-6">
          <input type="text" id="valve" class="form-control" [formControl]="valve" maxlength="50">
          @if (valve.errors && (valve.dirty || valve.touched)) {
            @if (valve.errors.required) {
              <div class="invalid-feedback force-show small">
                Valve is required.
              </div>
            }
            @if (valve.errors.maxlength) {
              <div class="invalid-feedback force-show small">
                No more than 50 chars.
              </div>
            }
          }
        </div>
      </div>
    </div>

    <div class="form-group fs-12">
      <div class="row">
        <div class="col-lg col-lg-3">
          <label class="text-sm-right d-block text-capitalize" for="solenoid-1">
            {{ getFuncLabel(dataCardType) }} 1
          </label>
        </div>
        <div class="col-lg col-lg-6">
          <input type="text" id="solenoid-1" class="form-control" [formControl]="sol1" maxlength="50">
          @if (sol1.errors && (sol1.dirty || sol1.touched)) {
            @if (sol1.errors.required) {
              <div class="invalid-feedback force-show small">
                Solenoid 1 is required.
              </div>
            }
            @if (sol1.errors.maxlength) {
              <div class="invalid-feedback force-show small">
                No more than 50 chars.
              </div>
            }
          }
        </div>
      </div>
    </div>

    <div class="form-group fs-12 mb-3">
      <div class="row">
        <div class="col-lg col-lg-3">
          <label class="text-sm-right d-block text-capitalize" for="solenoid-2">
            {{ getFuncLabel(dataCardType) }} 2
          </label>
        </div>
        <div class="col-lg col-lg-6">
          <input type="text" id="solenoid-2" class="form-control" [formControl]="sol2" maxlength="50">
          @if (sol2.errors && (sol2.dirty || sol2.touched)) {
            @if (sol2.errors.required) {
              <div class="invalid-feedback force-show small">
                Solenoid 2 is required.
              </div>
            }
            @if (sol2.errors.maxlength) {
              <div class="invalid-feedback force-show small">
                No more than 50 chars.
              </div>
            }
          }
        </div>
      </div>
    </div>
  }

  <!-- Deviation URL -->
  @if (displayUrlForm) {
    <hr>
    <div class="form-group">
      <h4 class="fs-12 font-weight-bold">Deviation Register</h4>
    </div>
    <div class="form-group">
      <div class="row">
        <div class="col col-lg-12">
          <input
            type="text"
            class="form-control"
            [formControl]="url"
            placeholder="Paste URL link..."/>
          @if (url.errors && (url.dirty || url.touched)) {
            @if (url.errors.pattern) {
              <div class="invalid-feedback force-show">
                This is not a valid URL.
              </div>
            }
          }
        </div>
        @if (urlFormData?.lastChangedBy) {
          <div class="col col-lg-12 mt-2 fs-12">
            <strong>Last changed:</strong>
            on <strong>{{ urlFormData?.lastChanged | niceDate }}</strong>
            by <strong>{{ urlFormData?.lastChangedBy }}</strong>
          </div>
        }
      </div>
    </div>
  }

  @if ((displayMainForm && !disabledMainFormControls) || displayUrlForm) {
    <div class="col-lg col-lg-12 text-center">
      <button class="btn btn-info btn-filter" [disabled]="isInvalid()">Save</button>
    </div>
  }
</form>
